import React from 'react'
import _ from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import Lang from 'Lang/General'
import { Get, Post, Put } from 'utils/axios-token'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateIndustries: false,
      loading: false,
      industries: [],
      defaultQuery: {},
      industriesMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      searchParams: [
        {
          label: 'Title',
          value: 'title',
          col: 6,
          param: '',
          exact: true
        },
        {
          label: 'Status',
          col: 6,
          value: 'is_active',
          param: '',
          type: 'select',
          options: [
            {
              id: 'true',
              name: Lang['ACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language]
            },
            {
              id: 'false',
              name: Lang['INACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language]
            },
          ]
        },
      ],
      selectedIndustries: {},
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showViewIndustriesModal: false,
      query: {}
    }

    onChangeIndustriesHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getIndustries = query => {
      this.setState({ query: query })
      let tmpQuery = _.cloneDeep( query )
      tmpQuery = {
        ...tmpQuery,
        ...tmpQuery.filter
      }
      delete tmpQuery.filter
      Get(
        `/api/v1/fex/industries?query=${convertSearchObjectToBase64(tmpQuery)}`,
        this.getIndustriesSuccess,
        this.getIndustriesError,
        this.load
      )
    }
    getIndustriesSuccess = payload => this.setState({ 
      industries: _.map(payload.data, item => ({ ...item, status: Lang[item.is_active ? 'ACTIVE' : 'INACTIVE'][this.props.data.languageReducer.userSettings.admin_panel_language] })),
      industriesMeta: payload.meta
    })
    getIndustriesError = error => this.requestError(error.toString())

    createIndustries = dataToSubmit => {
      Post(
        `/api/v1/fex/industries`,
        dataToSubmit,
        this.createIndustriesSuccess,
        this.createIndustriesError,
        this.load
      )
    }
    createIndustriesSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreateIndustries: false,
        query: {
          page: 1,
          is_paginated: true,
          filter:{"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id},
        }
      }, () => this.getIndustries(this.state.query))
    }
    createIndustriesError = error => {
      if (error.name) {
        this.requestError(error.name)
      } else {
        this.requestError(error)
      }
    }

    getSelectedIndustries = id => {
      Get(
        `/api/v1/fex/industries/${id}`,
        this.getSelectedIndustriesSuccess,
        this.getSelectedIndustriesError,
        this.load
      )
    }
    getSelectedIndustriesSuccess = payload => this.setState({ selectedIndustries: payload, showEditModal: true })
    getSelectedIndustriesError = error => this.requestError(error)

    updateIndustries = (dataToSubmit) => {
      Put(
        `/api/v1/fex/industries/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateIndustriesSuccess,
        this.updateIndustriesError,
        this.load
      )
    }
    updateIndustriesSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        selectedIndustries: null,
        query: {
          page: 1,
          is_paginated: true,
          filter:{"client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id},
        }
      }, () => this.getIndustries(this.state.query))
    }
    updateIndustriesError = error => this.requestError(error)

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadIndustry={this.state.loading}
          getIndustries={this.getIndustries}
          createIndustries={this.createIndustries}
          getSelectedIndustries={this.getSelectedIndustries}
          updateIndustries={this.updateIndustries}
          onChangeIndustriesHOC={this.onChangeIndustriesHOC}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps)(WithHOC)
}

export default HOC
